import{i as r}from"../isObject-0b530d86.js";var i=r;export{i as isObject};
//# sourceMappingURL=is-object.js.map
